export function debounce(func, interval) {
  let timeout
  return function () {
    const context = this

    const args = arguments
    const later = function () {
      timeout = null
      func.apply(context, args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, interval || 200)
  }
}

export function slideInOutSearch() {
  const showSearchButton = document.querySelector('.c-nav__search')
  const search = document.querySelector('.c-search__form')
  if (showSearchButton && search) {
    showSearchButton.addEventListener('click', (e) => {
      if (search.dataset.active == 'false') {
        search.dataset.active = 'true'
        document.getElementById('s').focus();

        slide(search, true, 30)
        search.addEventListener(
          'transitionend',
          (e) => {
            search.classList.add('js-search-active')
          },
          { once: true },
        )
      } else {
        search.dataset.active = 'false'
        slide(search, false, 30)
        search.classList.remove('js-search-active')
      }
    })
  }
}

export function setNoResultsHeight() {
  const bodyHeight = document.body.getBoundingClientRect().height
  const windowHeight = window.screen.height
  const containerHeight = windowHeight - bodyHeight
  const container = document.querySelector('.search.section')
  if (containerHeight > 0) {
    container.setAttribute('style', `min-height: ${containerHeight}px;`)
  }
}

function slide(target, slideIn, modifier = 0) {
  if (slideIn) {
    target.style.height = 'auto'
    const height = `${target.clientHeight + modifier}px`
    target.style.height = '0px'
    setTimeout(() => {
      target.style.height = height
    }, 0)
  } else {
    target.style.height = '0px'
  }
}
